import Vue from "vue";
import Router from "vue-router";
import routes from "./routes.js";
import Cookies from "js-cookie";
import httpService from "@/http/http-common.js";
Vue.use(Router);

const router = new Router({
  routes,
  mode: "history",
  base: process.env.BASE_URL
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (router.app.$keycloak.authenticated) {
//       next()
//     } else {
//       const loginUrl = router.app.$keycloak.createLoginUrl()
//       window.location.replace(loginUrl)
//     }
//   } else {
//     next()
//   }
// })

router.beforeEach((to, from, next) => {

  if (to.meta.requiresAuth) {
    // Get the actual url of the app, it's needed for Keycloak
    let basePath = window.location.toString();
    if (!router.app.$keycloak.authenticated) {
      console.log("not authenticated");
      console.log(basePath);
      router.app.$keycloak.login({ redirectUri: "order.uphellas.gr" }).success(() => {
      });
    } else {
      // The user was authenticated, in keycloak and has the app role
      if (sessionStorage.getItem("user_data")) {
        let user = JSON.parse(sessionStorage.getItem("user_data"));
        // console.log(user.email + " " + router.app.$keycloak.idTokenParsed.email + " " + (user.email !== router.app.$keycloak.idTokenParsed.email))
        // console.log(user.email.toLowerCase().trim() + " " + router.app.$keycloak.idTokenParsed.email.toLowerCase().trim() + " " + (user.email.toLowerCase().trim() !== router.app.$keycloak.idTokenParsed.email.toLowerCase().trim()))
        if (user.email.toLowerCase().trim() !== router.app.$keycloak.idTokenParsed.email.toLowerCase().trim()) {
          Cookies.remove("userLink");
          Cookies.remove("token");

          sessionStorage.removeItem("selectedCompany");
          sessionStorage.removeItem("customer_data");
          sessionStorage.removeItem("user_data");
        }
      }
      if (Cookies.get("token")) {
        next();
      } else {
        let formData = {
          username: router.app.$keycloak.idTokenParsed.email,
          password: router.app.$keycloak.idTokenParsed.sub
        };
        console.log("get tokens");
        httpService.companyService
          .userLogin(formData)
          .then(function (response) {
            // handle success
            return response;
          })
          .then(response => {
            if (response.status == 200) {
              // navigare catre aplicatia noua
              let userLink = response.headers["link"].split(";")[0];
              userLink = userLink.replace(">", "");
              userLink = userLink.replace("<", "");
              Cookies.set("userLink", userLink, {
                expires: response.data.expires_in / (24 * 60 * 60),
                sameSite: "Lax"
              });
              Cookies.set("token", response.data.access_token, {
                expires: response.data.expires_in / (24 * 60 * 60),
                sameSite: "Lax"
              });

              // this.getUserData();
              next();
            } else {
              if (process.env.NODE_ENV === "production") {
                window.open("https://go.uphellas.gr/#/main", "_self");
              } else {
                // window.open("http://10.10.23.228:8180/auth/realms/uphellas", "_self");

                // router.app.$keycloak.logout();
              }
            }
          })
          .catch(error => {
            // handle error
            if (process.env.NODE_ENV === "production") {
              window.open("https://go.uphellas.gr/#/main", "_self");
            } else {
              // window.open("http://10.10.23.228:8180/auth/realms/uphellas", "_self");

              // router.app.$keycloak.logout();
            }
          });
      }
    }
  } else {
    next();
  }
});

export default router;
